import { markdownSerializer } from 'common/Prose/components/TextInlineFormatBar/components/FormatBars/markdownSerializer'
import { Button } from 'components/Button'
import { useCreateRevision, Selection } from 'hooks/queries/layers/revisions/useCreateRevision'
import { AllSelection, TextSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { RevisionType } from 'components/BlazeCommandLine/Types'
import { Wrench } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  view: EditorView
  articleId: string
  layerId: string
}

export const ImproveQualityAction = ({ view, articleId, layerId }: Props) => {
  const { isMobile } = useResponsiveDesign()

  const { mutate } = useCreateRevision(
    { articleKey: articleId, layerId },
    {
      onSuccess: () => {
        const tr = view.state.tr
        tr.setSelection(TextSelection.create(view.state.doc, 0))
        view.dispatch(tr)
      },
    },
  )

  const handleSubmit = () => {
    const selection = new AllSelection(view.state.doc).toJSON() as Selection
    const doc = view.state.doc
    const documentAsMarkdown = markdownSerializer.serialize(doc)

    mutate({
      prompt: {
        custom_prompt: 'Improve the quality of the writing in this document',
        revision_type: RevisionType.CUSTOM_PROMPT,
      },
      selection,
      selectionAsMarkdown: documentAsMarkdown,
      documentAsMarkdown,
    })
  }

  return (
    <Button
      aria-label="Improve quality"
      variant="tertiary"
      size="lg"
      frontIcon={() => <Wrench size={24} />}
      onPress={handleSubmit}
      id="improve-quality"
    >
      {isMobile ? 'Improve' : 'Improve Quality'}
    </Button>
  )
}
